import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getNotifications } from "../../firebase/services";
import { useAuth } from "../../hooks/useAuth";
import { format } from "date-fns";
import { useLanguage } from "../../hooks/useLanguage";

export default function PromoterNotifications() {
  const { t } = useLanguage();
  const { user } = useAuth();
  const [notifs, setNotifs] = useState([]);

  useEffect(() => {
    if (!user) return;
    const key = `promoterhq_notif_read_${user.uid}`;
    localStorage.setItem(key, Date.now().toString());
    getNotifications(user.uid).then(setNotifs);
  }, [user]);

  return (
    <>
      <div className="page-header"><h1>{t("notif.title")}</h1></div>
      <div className="card">
        {notifs.map(n => (
          <div key={n.id} className="notif-item">
            <div className="notif-icon">{n.type === "bonus_program" ? "🎁" : n.fileUrl ? "📎" : "📢"}</div>
            <div className="notif-content">
              <div className="notif-title">{n.title}</div>
              <div className="notif-sub">{n.createdAt?.toDate ? format(n.createdAt.toDate(), "dd/MM/yyyy HH:mm") : ""}</div>
              {n.body && <div style={{ fontSize:12, color:"#888", marginTop:4, whiteSpace:"pre-wrap" }}>{n.body}</div>}
              {n.type === "bonus_program" && <Link to="/promoter/programs" className="btn btn-sm" style={{ marginTop:8 }}>🎁 {t("bp.view")}</Link>}
              {n.fileUrl && <a href={n.fileUrl} target="_blank" rel="noreferrer" className="btn btn-sm" style={{ marginTop:8 }}>⬇ Tải tài liệu</a>}
            </div>
          </div>
        ))}
        {notifs.length === 0 && <div style={{ color:"#aaa", textAlign:"center", padding:24 }}>{t("notif.no_notifs")}</div>}
      </div>
    </>
  );
}
